import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { GroupEdit } from './GroupEdit';
import { GroupNotFound, GroupViewDetails } from './GroupView';
import GroupView from './GroupView/GroupView';
import useGroup from './GroupView/useGroup';
import PageLoader from './PageLoader';

export default function Group() {
  const { id } = useParams();
  const [group, setGroup] = useGroup(id);

  if (group.error) {
    return <GroupNotFound />;
  }

  return group.loading ? (
    <PageLoader />
  ) : (
    <div>
      <Routes>
        <Route path={`/details/edit`} element={<GroupEdit group={group.data} setGroup={setGroup} />} />
        <Route path={`/details`} element={<GroupViewDetails group={group.data} onGroupUpdate={setGroup} />} />
        <Route path={`/error`} element={<GroupNotFound />} />
        <Route index element={<GroupView group={group.data} />} />
      </Routes>
    </div>
  );
}
